<template>
  <div class="project-info-container">
    <el-form :model="projectForm" :rules="rules" ref="projectForm" label-width="100px" class="project-form">
      <el-form-item label="项目环境" prop="env">
        <el-select v-model="projectForm.env" placeholder="请选择项目区域">
          <el-option v-for="item in envList" :key="item.env" :label="item.label" :value="item.env"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="项目slug" prop="slug">
        <el-select v-model="projectForm.slug" placeholder="请选择medusa项目slug" clearable filterable remote :remote-method="getProjects" :loading="loading">
          <el-option v-for="item in projectList" :key="item.slug" :label="`${item.project_name}（${item.slug}）`" :value="item.slug">
          </el-option>
        </el-select>
        <el-button icon="el-icon-circle-plus-outline" class="new-project-button" type="text" @click="handleNewProject">新增项目slug</el-button>
      </el-form-item>
      <el-form-item label="项目名称" prop="projectName">
        <el-input v-model="projectForm.projectName" placeholder="请输入项目名称"></el-input>
      </el-form-item>
      <el-form-item label="默认路径" prop="path" title="项目路径不支持修改哦~">
        <el-input v-model="projectForm.path" placeholder="最好输入英文路径哦~" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="项目描述" prop="projectDescript">
        <el-input type="textarea" :rows="4" v-model="projectForm.projectDescript" placeholder="来为自己的项目说点什么吧..."></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="throttle(editProject,1000)">修改</el-button>
        <el-button @click="resetForm">重置</el-button>
      </el-form-item>
    </el-form>
    <!-- 对话框 -->
    <el-dialog :append-to-body='true' :close-on-click-modal="false" :close-on-press-escape="true" :top="dialog.top" :title="dialog.title" :visible.sync="dialog.visible" :width="dialog.width" :before-close="destroyComponent">
      <component @getProjects="getProjects" :is="dialog.component" @close="destroyComponent" />
    </el-dialog>
  </div>
</template>

<script>
import { showLoading, hideLoading } from '@/plugins/loading';
import { fileManageApi, medusaApi } from '@/api/index';
import { throttle } from '@/common/utils/timerUtil.js';
import { dialogMixin } from "@/common/mixins/";
import newSlug from "../newSlug.vue"
export default {
  mixins: [dialogMixin],
  name: 'base-info',
  props: {
    pId: {
      type: String,
      default: ''
    },
    envList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      projectForm: {
        env: '',
        slug: '',
        projectName: '',
        path: '',
        projectDescript: ''
      },
      projectList: [],
      rules: {
        projectName: [
          { required: true, message: '请输入项目名称', trigger: 'blur' },
          { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
        ],
        path: [
          {
            required: true, message: '请输入项目路径', trigger: 'blur'
          }
        ],
        slug: [
          { required: true, message: '请选择项目slug', trigger: 'change' }
        ],
        env: [
          { required: true, message: '请选择项目环境', trigger: 'change' }
        ],
        projectDescript: [
          { required: true, message: '请输入项目描述', trigger: 'blur' }
        ]
      },
      loading: false
    };
  },
  watch: {

  },
  mounted () {
    this.getProjectDetail();
    this.getProjects();
  },
  methods: {
    // 新增medusa项目
    handleNewProject () {
      this.setDialog(true, "新增美杜莎项目", newSlug, "600px", "25vh");
    },
    // 销毁动态组件
    destroyComponent () {
      this.setDialog(false, "", null, "1100px", "1vh");
    },
    // 获取项目列表
    getProjects (searchStr) {
      this.loading = true;
      setTimeout(async () => {
        this.loading = false;
        const res = await medusaApi.getProjects({ searchStr })
        if (res.code) {
          this.projectList = res.data;
        }
      }, 200);
    },
    // 节流
    throttle (fn, wait) {
      throttle(fn, wait);
    },
    // 编辑项目
    async editProject () {
      showLoading();
      const res = await fileManageApi.editProject({ ...this.projectForm, id: this.pId });
      if (res.code === 200) {
        this.$message.success(res.message);
        this.$emit('getProjectList');
        this.$emit('close');
      } else {
        this.$message.error(res.message);
      }
      hideLoading();
    },
    // 获取项目详情
    async getProjectDetail () {
      showLoading();
      const res = await this.$store.dispatch('project/getProjectDetail', this.pId);
      if (res.code === 200) {
        this.projectForm.env = res.data.env;
        this.projectForm.projectName = res.data.projectName;
        this.projectForm.path = res.data.path;
        this.projectForm.projectDescript = res.data.projectDescript;
        this.projectForm.slug = res.data.slug;
      } else {
        this.$message.error(res.message);
      }
      hideLoading();
    },
    // 重置表单
    resetForm () {
      this.projectForm.projectName = '';
      this.projectForm.projectDescript = '';
    }
  }
}
</script>

<style lang="scss" scoped>
.project-info-container {
  .project-form {
    .new-project-button {
      margin-left: 15px;
    }
  }
}
</style>

